import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
// import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown'
// import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import useWindowDimensions from '../_common/WindowDimesnions'
import HomeSubscriptionServiceItem from './HomeSubscriptionServiceItem'
import CustomCard from '../_common/CustomCard'

const HomeSubscriptionItem = (props) => {
  const {
    index,
    // group_name,
    title,
    base_price,
    currency,
    duration,
    services,
  } = props
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const [servicesData, setServicesData] = useState([])
  const [totalPrice, setTotalPrice] = useState(base_price)
  const [additionalPrice, setAdditionalPrice] = useState(0)
  // const [servicesScrolled, setServicesScrolled] = useState(false)

  const wrapperStyle = {
    height: '600px',
    margin: '0px 20px 10px 20px',
    background: theme.palette.oxfordBlue,
    borderRadius: '10px',
    boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.25)',
    padding: width >= constants.mdBreakpoint ? '20px' : '10px',
    color: 'white',
  }

  // const groupNameStyle = {
  //   minHeight: '50px',
  //   fontSize: width >= constants.xlBreakpoint ? '20px' : '18px',
  //   textAlign: 'center',
  //   color: theme.palette.violetsAreBlue,
  // }

  const titleStyle = {
    minHeight: '50px',
    fontSize: width >= constants.xlBreakpoint ? '20px' : '18px',
    textAlign: 'center',
  }

  const priceStyle = {
    fontSize: width >= constants.xlBreakpoint ? '28px' : '24px',
    textAlign: 'center',
    color: theme.palette.violetsAreBlue,
    paddingBottom: '25px',
  }

  const servicesLabelStyle = {
    fontSize: width >= constants.xlBreakpoint ? '18px' : '16px',
    textAlign: 'center',
    color: theme.palette.apple,
    paddingBottom: '20px',
  }

  // const scrollArrowStyle = {
  //   color: alpha(theme.palette.violetsAreBlue, 0.8),
  //   cusrsor: 'pointer',
  //   zIndex: '101',
  // }

  // const scrollToTop = () => {
  //   const element = document.getElementById('this_is_top')
  //   element.scrollIntoView({ behavior: 'smooth' })
  //   setServicesScrolled(false)
  // }

  // const scrollToEnd = () => {
  //   const element = document.getElementById('cont')
  //   element.scrollBy({ top: 50, behavior: 'smooth' })
  // }

  // const handleScroll = () => {
  //   const scrollableDiv = document.getElementById(`cont${index}`);
  //   const scrollHeight = scrollableDiv.scrollHeight;
  //   const clientHeight = scrollableDiv.clientHeight;
  //   const scrollTop = scrollableDiv.scrollTop;
    
  //   scrollableDiv.scrollTop = scrollHeight - clientHeight;
  // };

  useEffect(() => {
    const sortByPriority = (list) => {
      return [...list].sort((a, b) => a.priority - b.priority)
    }

    if (services && services.length > 0) {
      const services_data = sortByPriority(services)
      setServicesData(services_data)
    } else {
      setServicesData([])
    }
  }, [services])

  useEffect(() => {
    setTotalPrice(base_price + parseFloat(additionalPrice))
  }, [base_price, additionalPrice])
  
  return (
    <Box sx={wrapperStyle}>
      {/* <Box sx={groupNameStyle}>{group_name}</Box> */}
      <Box sx={titleStyle}>{title.value}</Box>
      <Box sx={priceStyle}>
        <Box component='span'>{totalPrice} </Box>
        <Box component='span' sx={{ textTransform: 'uppercase' }}>{currency} </Box>
        <Box component='span'>/ </Box>
        <Box component='span' sx={{ textTransform: 'capitalize' }}>{duration}</Box>
      </Box>
      <Box sx={servicesLabelStyle}>{defaultTexts.services}</Box>
      <CustomCard sx={{ height: '320px' }} marginRight={-18}>
        <Box id={'cont' + index} sx={{ height: '320px' }}>
          {/* <Box id='this_is_top'></Box> */}
          {
            servicesData.map((item, index) => (
              <HomeSubscriptionServiceItem
                key={index}
                {...item}
                currency={currency}
                setAdditionalPrice={setAdditionalPrice}
              />
            ))
          }
          {/* <Box id='this_is_end'></Box> */}
        </Box>        
      </CustomCard>
      {/* {
        servicesScrolled ?
        <Box>

        </Box> :
        <Box sx={scrollArrowStyle} onClick={handleScroll}>
          <ArrowCircleDownIcon />
        </Box>
      } */}
    </Box>
  )
}

export default HomeSubscriptionItem